
import { Component, Vue } from 'vue-property-decorator';
import OsGlobalDialogs from '@/components/app/OsGlobalDialogs.vue';
@Component({
  components: { OsGlobalDialogs }
})
export default class LoginLayout extends Vue {}
